import { axios } from '../../../services/axios';
import * as CONST from '../../constants';

const onSuccess = (dispatch, data) => {
  dispatch({ type: CONST.SUBSCRIPTION_CANCEL_REASON_LIST_SUCCESS, data });
};

const onFailed = (dispatch, error) => {
  dispatch({ type: CONST.SUBSCRIPTION_CANCEL_REASON_LIST_ERROR, error });
};

const handleResponse = (dispatch, response) => {
  if (response.status === 200) {
    onSuccess(dispatch, response.data);
  } else {
    onFailed(dispatch, response.data);
  }
};

export const cancelReaonsList = () => {
  return async (dispatch) => {
    dispatch({ type: CONST.SUBSCRIPTION_CANCEL_REASON_LIST_REQUEST });

    axios
      .get('/cancel-reasons', undefined)
      .then((response) => {
        handleResponse(dispatch, response);
      })
      .catch((error) => console.error(error));
  };
};
